// extracted by mini-css-extract-plugin
module.exports = {"link":"_02712f2b3b--link--Udy7o","arrow":"_02712f2b3b--arrow--A6LkA"};